module.exports = __webpack_public_path__ + "static/media/Jawbreak-Serif.2226c11f.eot";